import dayjs from 'dayjs';

export interface IEstatus {
  id?: number;
  idMensajeCobro?: string;
  cc?: string | null;
  mt?: number | null;
  hs?: number | null;
  hp?: number | null;
  e?: number | null;
  cr?: string | null;
  ncVendedor?: string | null;
  dvVendedor?: number | null;
  tcVendedor?: number | null;
  cbVendedor?: string | null;
  ciVendedor?: number | null;
  nbVendedor?: string | null;
  ncClient?: string | null;
  dvClient?: number | null;
  tcClient?: number | null;
  cbClient?: string | null;
  ciClient?: number | null;
  nbClient?: string | null;
  extra1?: string | null;
  extra2?: string | null;
  extra3?: string | null;
  extra4?: string | null;
  extra5?: string | null;
  extra6?: string | null;
  extra7?: string | null;
  extra8?: string | null;
  extra9?: string | null;
  extra10?: string | null;
  createdBy?: string | null;
  createdDate?: dayjs.Dayjs | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<IEstatus> = {};
